import stoneService from '@services/magento/stone.service';

import { ShipmentTrackingInfo } from '@stone/interfaces';

export async function fetchTrackingApi(shipmentId: number): Promise<ShipmentTrackingInfo> {
  const response = await stoneService.getStoneTrackingInfo(shipmentId);
  return Array.isArray(response) ? response[0] : response;
}
